/* eslint-disable import/no-mutable-exports */
var vorhabenMap = {
  init: function () {
  	
  
  }
};

export default vorhabenMap;